import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogTitle,
    withStyles,
    DialogContent,
    Grid,
    Typography,
    TextField,
} from 'material-ui';
import Select from 'react-select';
import {styles} from '../../style/staff_section';

class FindYourProjectSectionEditPopup extends React.Component {
    render() {
        let {
            title,
            onUpdateTitleField,
            classes,
            onHandleSubmit,
            onHandleClose,
            projects,
            selectedProjects,
            destinations,
            selectedDestinations,
        } = this.props;

        if (!selectedDestinations) selectedDestinations = [];

        if (!selectedProjects) selectedProjects = [];

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Find Your Project Section</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="title"
                            label="Title"
                            onChange={(event) => {
                                onUpdateTitleField(event.target.value);
                            }}
                            fullWidth
                            value={title || ''}
                        />
                        <Grid item xs={12} md={6}>
                            <Typography variant="subheading">
                                Top project(s) *
                            </Typography>
                            <Select
                                name="projects"
                                multi
                                closeOnSelect={false}
                                value={selectedProjects}
                                onChange={(selectedProjects) => {
                                    this.props.onProjectsChange(
                                        selectedProjects
                                    );
                                }}
                                options={projects}
                                labelKey={'display_name'}
                                valueKey={'id'}
                                valueRenderer={(option) => (
                                    <span>{option.display_name}</span>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="subheading">
                                Top destination(s) *
                            </Typography>
                            <Select
                                name="destinations"
                                multi
                                closeOnSelect={false}
                                value={selectedDestinations}
                                onChange={(selectedDestinations) => {
                                    this.props.onDestinationsChange(
                                        selectedDestinations
                                    );
                                }}
                                options={destinations}
                                labelKey={'display_name'}
                                valueKey={'id'}
                                valueRenderer={(option) => (
                                    <span>{option.display_name}</span>
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(FindYourProjectSectionEditPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/find_your_project_section_edit.js